export const filterRatesByCategory = <T extends { categoryIds?: string[] | null }>(
  rates: T[],
  selectedCategoryId: string | null
): T[] => {
  if (!selectedCategoryId) {
    return rates;
  }
  return rates.filter((rate) => (rate.categoryIds ?? []).includes(selectedCategoryId));
};
